module.exports = __webpack_public_path__ + "static/media/verification.7d5c7300.png";